import React from 'react';
import PlansCardFeatures from './PlansCardFeatures';

interface IPlansTableCardStatic {
  type: string;
  monthlyPrice: string;
  annualPrice: string;
  icon: any;
  activeBtn: string;
}

const PlansTableCardStatic: React.FC<IPlansTableCardStatic> = ({ type, annualPrice, monthlyPrice, icon, activeBtn }) => {
  return (
    <div className='plans-table-card'>
      <div className='plans-card-header'>
        <div className='plans-card-upper-group'>
          <div className='plans-card-heading-section'>
            <div className='plans-card-heading-icon'>
              {icon}
            </div>
            <div className='plans-card-type-text'>
              {type} plan
            </div>
          </div>
          <div className='plans-card-price-section'>
            {activeBtn === 'monthly' ? (
              <div className='plans-card-price-text'>
                {monthlyPrice}
              </div>
            ) : (
              <div className='plans-card-price-text'>
                {annualPrice}
              </div>
            )}
          </div>
          {activeBtn === 'monthly' && monthlyPrice === 'Contact Us' && (
            <div className='plans-card-support-text'>
              info@bitedata.io
            </div>
          )}
          {activeBtn === 'monthly' && monthlyPrice.includes('$') && (
            <div className='plans-card-support-text'>
              per month/per user
            </div>
          )}
          {activeBtn === 'annual' && annualPrice === 'Contact Us' && (
            <div className='plans-card-support-text'>
              info@bitedata.io
            </div>
          )}
          {activeBtn === 'annual' && annualPrice.includes('$') && (
            <div className='plans-card-support-text'>
              per month/per user
            </div>
          )}
        </div>
      </div>
      <div className='plans-card-content'>
        <PlansCardFeatures type={type} />
      </div>
    </div>
  );
};

export default PlansTableCardStatic;
